import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import reportWebVitals from './reportWebVitals'
import App from './Pages/App'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import config from './aws-exports'
import { ApiContextProvider } from './Services/apiService'
import { ThemeProvider } from '@aws-amplify/ui-react'
import { LoaderProvider } from './Context/LoaderProvider'

import '@aws-amplify/ui-react/styles.css' // default theme
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import 'react-dropzone-uploader/dist/styles.css'

Sentry.init({
  dsn: config.sentry_dsn,
  environment: config.stage,
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
})

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <ApiContextProvider>
        <LoaderProvider>
          <App />
        </LoaderProvider>
      </ApiContextProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
